__turbopack_context__.v({
  "closeBtn": "Modal-module-scss-module__aj1leq__closeBtn",
  "colorbar": "Modal-module-scss-module__aj1leq__colorbar",
  "modal": "Modal-module-scss-module__aj1leq__modal",
  "modalContent": "Modal-module-scss-module__aj1leq__modalContent",
});
